import React from 'react'

import PageContent from '@components/layout/PageContent'
import { PageHeading } from '@components/layout/Heading'
import { Card, Text, Flex } from '@clear/design-system'
import { ApplicantStatusDetails } from '@clear-denver/tpc-openapi-typescript/build/v1/enrollment'

interface ApplicationFoundProps {
  data: ApplicantStatusDetails
}

const ApplicationFound: React.FC<ApplicationFoundProps> = ({ data }) => {
  return (
    <PageContent>
      <PageHeading color="brandDarkBlue" fontSize={6}>
        Check Status
      </PageHeading>
      <Card px={0} py={5}>
        <Text
          as="h1"
          variant="display"
          fontSize={8}
          my={5}
          textAlign="center"
          color="brandDarkBlue"
        >
          {data.name.noMiddleName === false
            ? `${data.name.firstName} ${data.name.middleName} ${data.name.lastName}`
            : `${data.name.firstName} ${data.name.lastName}`}
        </Text>
        <Flex
          flexDirection="row"
          justifyContent="space-around"
          width={['full']}
        >
          <Flex flexDirection="column">
            <Text variant="body" fontSize={1} my={1} textAlign="center">
              Status as of
            </Text>
            <Text
              as="h6"
              variant="display"
              fontSize={2}
              textAlign="center"
              color="brandDarkBlue"
            >
              {data?.asOfDate
                ? new Date().toLocaleDateString('en-US', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric',
                  })
                : ''}
            </Text>
          </Flex>
          <Flex flexDirection="column">
            <Text variant="body" fontSize={1} my={1} textAlign="center">
              Clear Application Id
            </Text>
            <Text
              as="h6"
              variant="display"
              fontSize={2}
              textAlign="center"
              color="brandDarkBlue"
            >
              {data.applicationId}
            </Text>
          </Flex>
        </Flex>
        <Flex
          width={['full']}
          backgroundColor="utilityTSASuccessGreen"
          my={6}
          py={2}
          justifyContent="center"
        >
          <Text
            variant="body"
            fontSize={1}
            textAlign="center"
            color="neutralsWhite"
            fontWeight={500}
          >
            {
              // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
              data?.determinationStatus!.toUpperCase()
            }
          </Text>
        </Flex>
        <Flex justifyContent="center" width="80%">
          <Text
            variant="body"
            fontSize={1}
            my={1}
            textAlign="center"
            alignSelf="center"
          >
            {data?.statusMessage}
          </Text>
        </Flex>
        {data?.receipt && (
          <>
            <Flex
              flexDirection="row"
              justifyContent="space-between"
              width={['90%']}
              py={2}
              mt={5}
              sx={{
                borderBottomWidth: '2px',
                borderBottomStyle: 'solid',
                borderBottomColor: 'neutralsBackgroundGray',
              }}
            >
              <Text
                variant="body"
                width={'33%'}
                maxWidth={'33%'}
                fontSize={1}
                my={1}
              >
                Card
              </Text>
              <Text variant="body" width={'33%'} maxWidth={'33%'} fontSize={1}>
                Amount
              </Text>
              <Text variant="body" fontSize={1} mr={94} my={1}>
                Date{' '}
              </Text>
            </Flex>
            <Flex
              flexDirection="row"
              justifyContent="space-between"
              width={['90%']}
              py={2}
            >
              <Text
                variant="body"
                width={'33%'}
                maxWidth={'33%'}
                fontSize={2}
                my={1}
              >
                {data?.receipt?.cardType}
              </Text>
              <Text variant="body" width={'33%'} maxWidth={'33%'} fontSize={2}>
                ${data?.receipt?.amountPaid}
              </Text>
              <Text variant="body" fontSize={2} my={1}>
                {data?.receipt?.chargeDate?.toDateString()}
              </Text>
            </Flex>
          </>
        )}
      </Card>
    </PageContent>
  )
}
export default ApplicationFound
